import React, { useEffect, useState } from 'react'
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from 'react-router-dom';
//  cookie functions
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
// svg icons
import IMAGES from "../../assets/images";

import './ScanQrCode.scss'

import FreezScreen from "../../components/FreezScreen";
import Pending from '../../components/status-svg/Pending';
import Processing from '../../components/status-svg/Processing';
import Success from '../../components/status-svg/Success';
import Failed from '../../components/status-svg/Failed';
import Cancel from '../../components/status-svg/Cancel';
import { waiterService } from '../../services';
import InvoiceData from '../../components/InvoiceData/invoiceData';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useParams } from "react-router-dom";
import Header from '../../components/Header/Header';
// import { handleScanQrcode } from '../../helper/qrCodeScanner';
import { Html5QrcodeScanner, Html5Qrcode } from 'html5-qrcode';
import qrscanner from "../../assets/images/qrscanner.jpg"
import scanbg from "../../assets/images/scanbg.svg"

enum Html5QrcodeSupportedFormats {
  QR_CODE = 0,
  AZTEC,
  CODABAR,
  CODE_39,
  CODE_93,
  CODE_128,
  DATA_MATRIX,
  MAXICODE,
  ITF,
  EAN_13,
  EAN_8,
  PDF_417,
  RSS_14,
  RSS_EXPANDED,
  UPC_A,
  UPC_E,
  UPC_EAN_EXTENSION,
}
function ScanQrCode() {
  let navigate = useNavigate();
  const { invoiceData, langValue } = useSelector((state: RootState) => state.waiter);
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isScanning, setisScanning] = useState(false)
  const [scannerObj, setscannerObj] = useState(null)
  const [cameraPermissionGranted, setCameraPermissionGranted] = useState(false);


  const {
    langValueState,
    freezScreenState,
    alertMessageState,
    invoiceState,
    setInvoiceMarkedpopup
  } = bindActionCreators(actionCreators, dispatch);


  useEffect(() => {
    if (cameraPermissionGranted) {
      const style = document.createElement('style');
      style.innerHTML = `body { background: #fff !important; }`;
      document.head.appendChild(style);
    } else {
      const style = document.createElement('style');
      style.innerHTML = `body { background: #EB5B5E !important; }`;
      document.head.appendChild(style);
    }

  }, [cameraPermissionGranted]);

  useEffect(() => {
    console.log(cameraPermissionGranted)
  }, [cameraPermissionGranted])


  const handleScanQrcode = () => {

    const html5QrCode = new Html5Qrcode("qr-reader");
    const qrCodeSuccessCallback = (decodedText: any, decodedResult: any) => {
      console.log(`Scan result: ${decodedText}`, decodedResult);
      window.location.replace(`${decodedText}`,);
      html5QrCode.clear();
    };

    const qrCodeErrorCallback = (error: any) => {
      console.error('Error getting userMedia:', error);
    };

    const config = { fps: 10, qrbox: 250 };

    html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback, qrCodeErrorCallback)
      .then(() => setCameraPermissionGranted(true))
      .catch((error: any) => console.error('Error starting QR code scanner:', error));
    return () => {
      html5QrCode.clear();
    };
  }


  const handleStopCamera = () => {
    window.location.reload();
  }






  return (
    <>
      <Grid id={`${!cameraPermissionGranted ? "ScanQrCode" : "ScanQrCodeStart"}`} container justifyContent="center" className={`${!cameraPermissionGranted ? "vh-10" : ""}`} >
        {!cameraPermissionGranted ? <Grid className="centerColumn" item xs={12} md={6}>
          <Header userFor={false} callingFrom="ScanQrCode" />
          <div className="row mx-0  d-flex justify-content-center align-items-center">
            <div className="textDiv px-4 mt-5 pt-3">
              <h1 className='familysora600'> {t("Forms.Lets-order")}</h1>
              <p className='familysora600'> {t("Forms.Scan-Qrcode-to-review")}</p>
            </div>

            <div className={`col-12 px-0 h-100  d-flex flex-column align-items-center ${!cameraPermissionGranted ? "mainColumn" : 'pt-2'}`}>
              {/* {!cameraPermissionGranted ? <>
                <h1 className='text-center familysora600'>SCAN QR CODE</h1>
              <img className='mb-3' height={300} width={300} src={qrscanner} alt="qrscanner" />
              </>: "" } */}
              {/* <main>
                <div id="qr-reader"></div>
                <div id="result"></div>
              </main> */}


              <div className='d-flex justify-content-center py-3 bottomInvoiceBtn px-3' >    <Button className='w-100 py-3 familysora600' onClick={() => handleScanQrcode()} > {t("Forms.Scan-QR-Code")} <img className='mx-2' src={scanbg} alt="scanbg" /> </Button></div>



            </div>
          </div>
        </Grid> : <>


          <div className={`col-12 px-0 h-100 `}>
            <span>
              <IconButton
                onClick={() => handleStopCamera()}
                className={`backBtn ${langValue === "ar" ? "backBtnAr" : ""
                  }`}
              >
                {langValue === "ar" ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}


              </IconButton>
            </span>
            {/* <main>
                <div id="qr-reader"></div>
                <div id="result"></div>
              </main> */}
          </div>


        </>}

        <main>
          <div id="qr-reader"></div>
          <div id="result"></div>
        </main>

      </Grid>
    </>)
}

export default withTranslation()(ScanQrCode);